'use client';

import { useMemo, useSyncExternalStore } from 'react';

import { safeJsonParse } from '../storage/helpers';

import {
  readStoredCheckoutProducts,
  subscribeCheckoutProducts,
} from './checkoutProductsStore';
import { type CheckoutProduct } from './types';

export function useCheckoutProducts(): CheckoutProduct[] | undefined {
  const stored = useSyncExternalStore(
    subscribeCheckoutProducts,
    readStoredCheckoutProducts,
    () => null
  );

  return useMemo(() => safeJsonParse(stored, {}).products, [stored]);
}
